import { render, staticRenderFns } from "./1_index.vue?vue&type=template&id=7200c29e&scoped=true&"
import script from "./1_index.vue?vue&type=script&lang=js&"
export * from "./1_index.vue?vue&type=script&lang=js&"
import style0 from "./1_index.vue?vue&type=style&index=0&id=7200c29e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7200c29e",
  null
  
)

export default component.exports